/* unplugin-vue-components disabled */import __unplugin_components_3 from '~icons/custom/invisible-icon';
import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/custom/visible-icon';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex justify-end marginB30"
};
const _hoisted_2 = {
  class: "flex items-center width100"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkRealNameConfigList, apiUsdkDelRealNameConfig } from '@/api/usdk';
import AddOrEditParamsRealName from './addOrEditParamsRealName.vue';
import { UseGlobalConfig } from '@/utils/hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'paramsRealName',
  props: {
    gameInfo: {
      type: Object
    }
  },
  setup(__props) {
    const props = __props;
    const columns = [{
      label: 'ProductId',
      prop: 'productId'
    }, {
      label: '渠道名称',
      prop: 'channel'
    }, {
      label: 'AppId',
      prop: 'appId'
    }, {
      label: 'secretKey',
      prop: 'secretKey',
      slot: 'secretKey'
    }, {
      label: '备案识别码',
      prop: 'filingCode'
    }, {
      label: '生效时间',
      prop: 'startTime',
      slot: 'startTime'
    }, {
      label: '失效时间',
      prop: 'invalidTime',
      slot: 'invalidTime'
    }, {
      label: '操作',
      action: true
    }];
    const {
      $filters
    } = UseGlobalConfig();
    const addOrEditParamsRealNameRef = ref();
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkRealNameConfigList({
        gid: props.gameInfo && props.gameInfo.Id
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const togglePassword = row => {
      row.show = !row.show;
    };
    const hideSecretKey = value => {
      return '*'.repeat(value.length);
    };
    const computedInvalidTime = computed(() => {
      return row => {
        let timeDiff = Number(row.invalidTime) - +new Date();
        if (timeDiff > 0 && Math.floor(timeDiff / (1000 * 60 * 60 * 24)) < 7 || Number(row.invalidTime) < +new Date()) {
          return {
            color: 'red',
            time: $filters.formatDate(Number(row.invalidTime))
          };
        } else {
          return {
            color: '',
            time: $filters.formatDate(Number(row.invalidTime))
          };
        }
      };
    });
    const handleClick = (type, data) => {
      console.log('object');
      if (type === 'add' || type === 'edit') {
        addOrEditParamsRealNameRef.value.show({
          type,
          data
        });
      } else {
        ElMessageBox.confirm('你确定删除此参数吗', '提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiUsdkDelRealNameConfig({
            productId: data.productId
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    watch(() => props.gameInfo, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_i_custom_visible_icon = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_i_custom_invisible_icon = __unplugin_components_3;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
      }, {
        default: _withCtx(() => [_createTextVNode("批量修改")]),
        _: 1
      })]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        pagination: "",
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        total: _unref(total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        secretKey: _withCtx(({
          scope
        }) => [_createElementVNode("div", _hoisted_2, [scope.row.show ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(scope.row.secretKey), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(hideSecretKey(scope.row.secretKey)), 1)), scope.row.secretKey && !scope.row.show ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          size: 20,
          class: "marginL10 cp",
          style: {
            "margin-bottom": "4px"
          },
          onClick: $event => togglePassword(scope.row)
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_visible_icon)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.secretKey && scope.row.show ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 3,
          size: 20,
          class: "marginL10 cp",
          style: {
            "margin-bottom": "2px"
          },
          onClick: $event => togglePassword(scope.row)
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_invisible_icon)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
        startTime: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(_unref($filters).formatDate(Number(scope.row.startTime))), 1)]),
        invalidTime: _withCtx(({
          scope
        }) => [_createElementVNode("span", {
          style: _normalizeStyle(`color: ${_unref(computedInvalidTime)(scope.row).color}`)
        }, _toDisplayString(_unref(computedInvalidTime)(scope.row).time), 5)]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"]), _createVNode(AddOrEditParamsRealName, {
        ref_key: "addOrEditParamsRealNameRef",
        ref: addOrEditParamsRealNameRef,
        gid: __props.gameInfo && __props.gameInfo.Id,
        onSuccess: getTableData
      }, null, 8, ["gid"])], 64);
    };
  }
});